import React from "react"
import { graphql, PageProps } from "gatsby"
import { TransparenzProfilePageQueryType } from "../types"
import { TransparenzProfilComponent } from "../components/pages/transparenz-profil"

const InterimMandate = ({
  location,
  data,
}: PageProps<TransparenzProfilePageQueryType>) => {
  const { team, transparenzrichtlinie } = data

  const profil = transparenzrichtlinie.nodes.find(
    (x) => x.frontmatter.id === "automotive-medtech-media"
  )

  console.log(profil)

  if (!profil) {
    return null
  }
  return (
    <TransparenzProfilComponent
      data={profil.frontmatter}
      nodes={team.nodes}
      pathname={location.pathname}
      englishPathname={"Test"}
      germanPathname={"Test"}
    />
  )
}

export const query = graphql`
  query {
    transparenzrichtlinie: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/transparenzrichtlinie/" } }
    ) {
      nodes {
        frontmatter {
          title
          type
          id
          contact
          gender
          content
          seoDetails {
            metadesc
            seo_title
          }
        }
      }
    }
    team: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/team/" } }
    ) {
      nodes {
        frontmatter {
          de {
            path
            xing
            position
            phone
            name
            linkedin
            thumbnail
            image_alt
            calendly
          }
        }
      }
    }
  }
`

export default InterimMandate
